/* eslint-disable import/no-anonymous-default-export */
import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import AddUserSliceReducer from "../Slice/Users/AddUserSlice";
import DeleteUserDataReducer from "../Slice/Users/DeleteUserSlice";
import LoginSliceReducer from "../Slice/Auth/LoginSlice";
import RolesSliceReducer from "../Slice/Users/RolesSlice";
import SingleUserDataSliceReducer from "../Slice/Users/SingleUserSlice";
import UpdateUserSliceReducer from "../Slice/Users/UpdateUserSlice";
import UsersListSliceReducer from "../Slice/Users/UserListSlice";
import VerifiedUserSliceReducer from "../Slice/Auth/VerifyUserSlice";
import SportsListSliceReducer from "../Slice/Sports/SportsListSlice";
import FacilitiesListSliceReducer from "../Slice/Facilities/FacilitiesListSlice";
import SingleFacilityDataSliceReducer from "../Slice/Facilities/SingleFacilitySlice";
import CourtsListSliceReducer from "../Slice/Courts/CourtsListSlice";
import StateListSliceReducer from "../Slice/Users/StateListSlice";
import ProfileDetailSliceReducer from "../Slice/Profile/ProfileDetailSlice";
import CoachesListSliceReducer from "../Slice/Coaches/CoachesListSlice";
import CourtBookingListSliceReducer from "../Slice/CourtBooking/CourtBookingListSlice";
import SessionsListSliceReducer from "../Slice/Sessions/SessionsListSlice";
import storage from 'redux-persist/lib/storage'
import EnumsScliceReducer from "../Slice/Users/EnumsSclice";
import CoachingBookingListSlice from "../Slice/CoachingBooking/CoachingBookingListSlice";
import PromotionalOffersListSliceReducer from "../Slice/PromotionalOffer/PromotionalOffersListSlice";
import SettingSlice from "../Slice/Settings/SettingSlice";
import SoldOrderListSlice from "../Slice/Pos/SoldOrderListSlice";
import RentedOrderListSlice from "../Slice/Pos/RentedOrderListSlice";
import AssociateBookingListSlice from "../Slice/AssociateBooking/AssociateBookingListSlice";
import NotificationCountSlice from "../Slice/NotificationCount/NotificationCountSlice";

const RootReducer = combineReducers({
  loginStatus: LoginSliceReducer,
  verifiedUser: VerifiedUserSliceReducer,
  addUser: AddUserSliceReducer,
  allUsers: UsersListSliceReducer,
  singleUser: SingleUserDataSliceReducer,
  userRoles: RolesSliceReducer,
  deleteUser: DeleteUserDataReducer,
  updateUser: UpdateUserSliceReducer,
  sportList: SportsListSliceReducer,
  facilityList: FacilitiesListSliceReducer,
  singleFacility: SingleFacilityDataSliceReducer,
  courtsList: CourtsListSliceReducer,
  states: StateListSliceReducer,
  profileDetail: ProfileDetailSliceReducer,
  coachList: CoachesListSliceReducer,
  bookedCourt: CourtBookingListSliceReducer,
  sessionList: SessionsListSliceReducer,
  enumsArray: EnumsScliceReducer,
  coachBooking: CoachingBookingListSlice,
  promotionalOffer: PromotionalOffersListSliceReducer,
  settings: SettingSlice,
  SoldOrderList: SoldOrderListSlice,
  RentedOrderList: RentedOrderListSlice,
  AssociateBookingList: AssociateBookingListSlice,
  NotificationCount: NotificationCountSlice
});

const PersistConfig = {
  key: "root",
  storage,
};

const PersistedReducer = persistReducer(PersistConfig, RootReducer)

export default function (state: any, action: any) {
  if (action.type === 'RESET') {
    storage.removeItem('persist:root')
    return PersistedReducer(undefined, action)
  }

  return PersistedReducer(state, action)
}
